import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SlackMessagePage } from './slack-message.page';

const routes: Routes = [
  {
    path: ':outboundId',
    component: SlackMessagePage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SlackMessagePageRoutingModule {}
